import {globals} from 'ah-tools';

export const COLOR_PRIMARY = globals.COLOR_PRIMARY || '#61DAFB';
export const COLOR_SECONDARY = globals.COLOR_SECONDARY || '#222222';
export const COLOR_CONTRAST = globals.COLOR_CONTRAST || '#FFFFFF';
export const COLOR_ALERT = globals.COLOR_ALERT || '#ff695e';
export const COLOR_POSITIVE = globals.COLOR_POSITIVE || 'green';
export const COLOR_WARNING = globals.COLOR_WARNING || 'orange';

export const DATE_FORMAT = globals.DATE_FORMAT || 'dddd, DD. MMM YYYY';
export const DATE_FORMAT_FULL = globals.DATE_FORMAT_FULL || 'dddd, DD. MMM YYYY - HH:mm';



export const MIN_PASSWORD_LENGTH = 6;

export const PRODUCTION_MODE = process.env.NODE_ENV === 'production';
export const WORKER_LOGIN = Boolean(process.env.REACT_APP_WORKER_LOGIN);

export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL || (PRODUCTION_MODE ? '//api.carperto.de/img/' : '//192.168.11.204/img/');
export const SUPPORT_LINK = process.env.REACT_APP_SUPPORT_URL || (PRODUCTION_MODE ? '//app.carperto.de/?support' : '//192.168.11.204:3000/?support');
export const API_URL = process.env.REACT_APP_API_URL || (PRODUCTION_MODE ? '//api.carperto.de/admin' : '//192.168.11.204/admin');


// WEBPACK FOOTER //
// ./src/misc/vars.js